import { TranslatableModel } from './translatable-model';
import { AccessorsMutatorsDecorator } from '../../helpers';
import { ReservationSource } from './reservation-source.model';
import { Guest } from './guests.model';
import moment from "moment/moment";

export class Reservation extends TranslatableModel {

    static get STATUSES_STYLES() {

        return {
            [Reservation.STATUS_CONFIRMED.key]: 'status_confirmed',
            [Reservation.STATUS_CONFIRMATION_PENDING.key]: 'status_confirmation_pending',
            [Reservation.STATUS_CANCELLED.key]: 'status_cancelled',
            [Reservation.STATUS_IN_HOUSE.key]: 'status_in_house',
            [Reservation.STATUS_CHECKED_OUT.key]: 'status_checked_out',
            [Reservation.STATUS_NO_SHOW.key]: 'status_no_show',
        };
    }

    static get STATUS_CONFIRMED() {

        return {
            key: 1,
            value: 'CONFIRMED'
        };
    }

    static get STATUS_CONFIRMATION_PENDING() {

        return {
            key: 2,
            value: 'CONFIRMATION_PENDING'
        };
    }

    static get STATUS_CANCELLED() {

        return {
            key: 3,
            value: 'CANCELLED'
        };
    }

    static get STATUS_IN_HOUSE() {

        return {
            key: 4,
            value: 'IN_HOUSE'
        };
    }

    static get STATUS_CHECKED_OUT() {

        return {
            key: 5,
            value: 'CHECKED_OUT'
        };
    }

    static get STATUS_NO_SHOW() {

        return {
            key: 6,
            value: 'NO_SHOW'
        };
    }

    static get STATUSES() {

        return [
            this.STATUS_CONFIRMED,
            this.STATUS_CONFIRMATION_PENDING,
            this.STATUS_CANCELLED,
            this.STATUS_IN_HOUSE,
            this.STATUS_CHECKED_OUT,
            this.STATUS_NO_SHOW,
        ];
    }

    static get ONLINE_STATUSES() {

        return [
            this.STATUS_CONFIRMED,
            this.STATUS_CONFIRMATION_PENDING,
            this.STATUS_CANCELLED,
        ];
    }

    static get CANNOT_CHECK_IN_STATUSES() {

        return [
            this.STATUS_IN_HOUSE,
            this.STATUS_CHECKED_OUT,
            this.STATUS_CANCELLED,
            this.STATUS_NO_SHOW,
        ];
    }

    static get BOOK_START_FILTER(){

        return 'dateBookedFilter';
    }

    static get CHECK_IN_START_FILTER(){

        return 'checkInFilter';
    }

    static get CHECK_OUT_START_FILTER(){

        return 'checkOutFilter';
    }

    static get STAY_DAY_FILTER(){

        return 'stayDateFilter';
    }

    fill(attributes = {}) {

        super.fill(attributes);

        this.room_numbers = this.allRooms();
    }

    getCheckOutDate() {

        if (this.same_day_checkout) {

            return moment(this.check_out).subtract(1, 'day').format('YYYY-MM-DD');
        }

        return this.check_out;
    }

    setGuest(value) {

        return value && (value instanceof Guest ? value : new Guest(value));
    }

    setReservationSource(value) {

        return value && (value instanceof ReservationSource ? value : new ReservationSource(value));
    }

    setRoomNumbers(value = []) {

        return value;
    }

    allRooms() {

        return (this.accommodations || [])
            .map(type => type.rooms)
            .reduce((rooms, room) => rooms.concat(room), []);
    }

    formatGuestName() {

        return this.guest.fullName();
    }

    formatRoomNumbers() {

        if (!(this.room_name || this.room_numbers && this.room_numbers.length)) {

            return null;
        }

        return this.room_numbers.map(this.extractRoomName()).join(', ') || this.room_name;
    }

    extractRoomName() {

        return ({abbreviation}) => abbreviation;
    }
}
AccessorsMutatorsDecorator(
    'id',
    'check_in',
    'check_out',
    'total_price',
    'status',
    'reservation_source',
    'guest',
    'property_id',
    'created_at',
    'property',
    'balance_due',
    'room_numbers',
    'reservation_source_id',
    'accommodations',
    'cancellation_ident',
    'number_of_nights',
    'estimated_arrival_time',
    'ident',
    'guests_quantity',
    'grand_total',
    'deposit',
    "security_deposit",
    "paid_out_amount",
    'total_fees',
    'total_taxes',
    'sub_total',
    'amount_paid',
    'custom_fields',
    'used_taxes',
    'used_fees',
    'additional_items',
    'additional_guests_count',
    'additional_childs',
    'room_name',
    'revenue',
    'guest_name',
    'notes',
    'reservation_source_deleted',
    'payment_type',
    'ota_total_price',
    'ota_currency',
    'ota_channel',
    'same_day_checkout',
    'last_extended_at',
    'check_in_at',
    'checkout_at',
    'cancelled_at',
    'confirmed_at',
    'reservation_source_name'
)(Reservation);



// WEBPACK FOOTER //
// ./src/pms-api/models/reservation.model.js